import React from 'react';
import './confirm-modal.scss';
import { SwipeableDrawer } from '@mui/material';
import { SVGS } from '../../../assets';
import { CommonButton } from '../../../components';

interface ConfirmModalProps {
  open: boolean;
  heading: string;
  description: string;
  onClose: () => void;
  onConfirmPress: () => void;
  isLoading?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  heading,
  description,
  onClose,
  onConfirmPress,
  isLoading,
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen={true}
      PaperProps={{
        className: 'confirm-modal__drawer-paper',
        role: 'dialog',
      }}
    >
      <div className="confirm-modal-container">
        <img
          src={SVGS.ConfirmCheckMark}
          alt="Success icon"
          width={120}
          height={120}
        />
        <div className="confirm-modal-content">
          <div className="message font-semibold">{heading}</div>
          <div className="description font-regular">{description}</div>
        </div>
      </div>

      <div className="confirm-modal-buttons">
        <CommonButton
          text="Cancel"
          buttonStyle="cancel-view"
          textStyle="cancel-view-text font-semibold"
          onPress={onClose}
        />
        <CommonButton
          text="Confirm"
          buttonStyle="confirm-view"
          textStyle="confirm-view-text font-semibold"
          onPress={onConfirmPress}
          loading={isLoading}
          spinnerColor="#fff"
          spinnerSize={21}
        />
      </div>
    </SwipeableDrawer>
  );
};
